import React from "react";
import PropTypes from "prop-types";
import Suggestion from "../Suggestion/index.js";
import GoogleEstablishmentShape from "../../shapes/GoogleEstablishmentShape.js";

var GoogleSuggestion = function GoogleSuggestion(_ref) {
  var suggestion = _ref.suggestion;
  var _suggestion$structure = suggestion.structured_formatting,
      name = _suggestion$structure.main_text,
      address = _suggestion$structure.secondary_text;
  return React.createElement(Suggestion, {
    main: name,
    secondary: address
  });
};

process.env.NODE_ENV !== "production" ? GoogleSuggestion.propTypes = {
  suggestion: PropTypes.shape(GoogleEstablishmentShape).isRequired
} : void 0;
export default GoogleSuggestion;